export const soldItemsForExcelExportFields: {
	farsiTitle?: string;
	fieldName?: string;
	value?: any;
}[] = [
	{
		fieldName: 'symbolName',
		farsiTitle: 'نام نماد'
	},
	{
		fieldName: 'persianDate',
		farsiTitle: 'تاریخ آخرین تراکنش/رویداد'
	},
	{
		fieldName: 'asset',
		farsiTitle: 'تعداد دارایی'
	},
	{
		fieldName: 'bonusShareVolume',
		farsiTitle: 'تعداد سهام جایزه'
	},
	{
		fieldName: 'stockRightVolume',
		farsiTitle: 'تعداد حق تقدم'
	},
	{
		fieldName: 'periodicDPSAmount',
		farsiTitle: 'سود نقدی مجامع در آخرین دوره'
	},
	{
		fieldName: 'lastDPSAmount',
		farsiTitle: 'آخرین سود نقدی مجمع'
	},
	{
		fieldName: 'totalDPSAmount',
		farsiTitle: 'سود نقدی کل مجامع'
	},
	{
		fieldName: 'periodicBuyAveragePrice',
		farsiTitle: 'قیمت میانگین خرید در آخرین دوره با لحاظ کارمزد'
	},
	{
		fieldName: 'periodicBuyAveragePriceWithoutDps',
		farsiTitle: 'قیمت میانگین خرید در آخرین دوره تعدیل نشده توسط سود نقدی مجمع با لحاظ کارمزد'
	},
	{
		fieldName: 'totalBuyAveragePrice',
		farsiTitle: 'قیمت میانگین کل خرید با لحاظ کارمزد'
	},
	{
		fieldName: 'totalBuyAveragePriceWithoutDps',
		farsiTitle: 'قیمت میانگین کل خرید تعدیل نشده توسط سود نقدی مجمع با لحاظ کارمزد'
	},
	{
		fieldName: 'periodicBuyAmount',
		farsiTitle: 'ارزش خرید ها در آخرین دوره با لحاظ کارمزد'
	},
	{
		fieldName: 'totalBuyAmount',
		farsiTitle: 'ارزش کل خرید ها با لحاظ کارمزد'
	},
	{
		fieldName: 'periodicSellAveragePrice',
		farsiTitle: 'قیمت میانگین فروش در آخرین دوره با لحاظ کارمزد'
	},
	{
		fieldName: 'totalSellAveragePrice',
		farsiTitle: 'قیمت میانگین کل فروش با لحاظ کارمزد'
	},
	{
		fieldName: 'periodicSellAmount',
		farsiTitle: 'ارزش فروش ها در آخرین دوره با لحاظ کارمزد'
	},
	{
		fieldName: 'totalSellAmount',
		farsiTitle: 'ارزش کل فروش ها با لحاظ کارمزد'
	},
	{
		fieldName: 'periodicBoughtVolume',
		farsiTitle: 'تعداد سهام خریداری شده در آخرین دوره'
	},
	{
		fieldName: 'totalBoughtVolume',
		farsiTitle: 'تعداد کل سهام خریداری شده'
	},
	{
		fieldName: 'periodicSoldVolume',
		farsiTitle: 'تعداد سهام فروخته شده در آخرین دوره'
	},
	{
		fieldName: 'totalSoldVolume',
		farsiTitle: 'تعداد کل سهام فروخته شده'
	},
	{
		fieldName: 'periodicRealizedProfitAndLoss',
		farsiTitle: 'سود/زیان حاصل از فروش سهام در آخرین دوره با لحاظ کارمزد'
	},
	{
		fieldName: 'periodicRealizedProfitAndLossWithoutDps',
		farsiTitle:
			'سود/زیان حاصل از فروش سهام در آخرین دوره با لحاظ کارمزد بر حسب میانگین خرید تعدیل نشده توسط سود نقدی مجمع'
	},
	{
		fieldName: 'totalRealizedProfitAndLoss',
		farsiTitle: 'سود/زیان کل حاصل از فروش سهام با لحاظ کارمزد'
	},
	{
		fieldName: 'totalRealizedProfitAndLossWithoutDps',
		farsiTitle: 'سود/زیان کل حاصل از فروش سهام با لحاظ کارمزد بر حسب میانگین خرید تعدیل نشده توسط سود نقدی مجمع'
	},
	{
		fieldName: 'title',
		farsiTitle: 'توضیح نماد'
	}
];
